import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  saveOrEditTreatmentPlanCard,
  pagingTreatmentPlanCard,
  getTreatmentPlanCardById,
  removeTreatmentPlanCard,
} from "app/services/TreatmentPlanCardService";
import { TYPE_CARD } from "app/common/LocalConst";
import {
  saveMedicalRequest,
  saveProductRequest,
} from "app/services/EncounterService";
import { RegisterService } from "app/common/Model/RegisterService";
import { pagingDrugOrder } from "app/services/DrugService";
import {
  getMedicalSupplyOderById,
  pagingMedicalSupplyOrder,
  removeMedical,
} from "app/services/MedicalSupplyService";
import { getMsOrderFromPatientAdvice } from "app/services/ProductService";

export default class RegisterMedicalSupplyStore {
  searchRegisterMedical = {
    ...new SearchObject(),
    fromDate: new Date(new Date().getFullYear(), 0, 1),
    toDate: new Date(),
    type: TYPE_CARD[0].value,
  };
  openConfirmDeleteMedical = null;
  openConfirmMessage = null;
  openUpdateMedicalSupplyAdvicePopup = false;
  openAddMedicalSupplyAdvicePopup = false;
  dataRegisterMedicalSupply = [];
  searchListMedicalSupplyAdvice = null;
  pageRegisterMedicalSupplyOrder = new PageResponse();
  openCreateOrEditMedicalSupplyOrderPopup = false;
  initRegisterMedicalSupply = { ...new RegisterService() };

  constructor() {
    makeAutoObservable(this);
  }
  pagingRegisterMedicalSupplyOrder = async () => {
    let { orderDate, ...orther } = this.searchRegisterMedical;
    return await pagingMedicalSupplyOrder({ ...orther, getStaffRevenues: true })
      .then(({ data }) => {
        this.pageRegisterMedicalSupplyOrder = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu sản phẩm có lỗi");
      });
  };

  saveOrUpdateRegisterMedicalSupplyOrder = async (values) => {
    let { drug, medicalSupply, ...ortherData } = values;
    let submitData = {};
    if (medicalSupply) {
      submitData = { medicalSupplyOrder: values };
    }
    return await saveMedicalRequest(submitData)
      .then(({ data }) => {
        this.openCreateOrEditMedicalSupplyOrderPopup = false;
        if (data?.medicalSupplyOrder?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.medicalSupplyOrder?.responseDetail;
          }, 500);
          return;
        } else {
          toast.success("Đăng ký vật tư y tế thành công");
          this.pagingRegisterMedicalSupplyOrder();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký sản phẩm có lỗi");
      });
  };

  handleChangeFormSearchMedical = (searchRegisterMedical) => {
    this.searchRegisterMedical = {
      ...this.searchRegisterMedical,
      ...searchRegisterMedical,
    };
    this.pagingRegisterMedicalSupplyOrder();
  };

  handleOpenCreateOrEditMedicalPopup = async (productRegister) => {
    if (Boolean(productRegister)) {
      getMedicalSupplyOderById(productRegister?.id).then(({ data }) => {
        if (data?.taxPercent) data.taxPercent = data?.taxPercent?.toString();
        this.initRegisterMedicalSupply = data;
        this.openCreateOrEditMedicalSupplyOrderPopup = true;
      });
    } else {
      this.initRegisterMedicalSupply = { ...new RegisterService() };
      this.openCreateOrEditMedicalSupplyOrderPopup = true;
    }
  };

  handleOpenAddMedicalSupplyAdvicePopup = async (obj) => {
    this.searchListMedicalSupplyAdvice = obj;
    getMsOrderFromPatientAdvice(obj).then(({ data }) => {
      this.dataRegisterMedicalSupply = data;
      this.openAddMedicalSupplyAdvicePopup = true;
    });
  };

  handleCloseCreateOrEditMedicalSupplyOrderPopup = () => {
    this.openCreateOrEditMedicalSupplyOrderPopup = false;
    this.initRegisterMedicalSupply = { ...new RegisterService() };
  };

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDeleteMedical = id;
  };

  saveOrUpdateMedicalSupplyAdvice = async (values) => {
    return await saveMedicalRequest({ medicalSupplyOrder: values })
      .then(({ data }) => {
        this.openAddMedicalSupplyAdvicePopup = false;
        toast.success("Đăng ký vật tư từ tư vấn thành công");
        getMsOrderFromPatientAdvice(this.searchListMedicalSupplyAdvice).then(
          ({ data }) => {
            this.dataRegisterMedicalSupply = data;
          }
        );
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký vật tư từ tư vấn có lỗi");
      });
  };

  handleCloseAddMedicalSupplyAdvicePopup = () => {
    this.openAddMedicalSupplyAdvicePopup = false;
  };

  handleCloseUpdateMedicalSupplyAdvicePopup = () => {
    this.openUpdateMedicalSupplyAdvicePopup = false;
  };

  handleOpenAddMedicalSpplyAdvicePopup = async (obj) => {
    this.searchListMedicalSupplyAdvice = obj;
    getMsOrderFromPatientAdvice(obj).then(({ data }) => {
      this.dataRegisterMedicalSupply = data;
      this.openAddMedicalSupplyAdvicePopup = true;
    });
  };

  handleDeleteMedicalSupplyOrder = async () => {
    return await removeMedical(this.openConfirmDeleteMedical)
      .then(({ data }) => {
        this.openConfirmDeleteMedical = null;
        if (data?.responseStatus === false) {
          toast.error(data?.responseDetail);
        } else {
          toast.success("Xóa sản phẩm thành công");
          this.pagingRegisterMedicalSupplyOrder();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa sản phẩm có lỗi");
      });
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  resetStore = () => {
    this.searchRegisterMedical = {
      ...new SearchObject(),
      fromDate: new Date(new Date().getFullYear(), 0, 1),
      toDate: new Date(),
      type: TYPE_CARD[0].value,
    };
    this.pageRegisterMedicalSupplyOrder = new PageResponse();
    this.openCreateOrEditMedicalSupplyOrderPopup = false;
    this.initRegisterMedicalSupply = { ...new RegisterService() };
    this.openConfirmMessage = null;
    this.searchListMedicalSupplyAdvice = null;
    this.dataRegisterMedicalSupply = [];
  };

  resetPopupStore = () => {
    this.initRegisterMedicalSupply = { ...new RegisterService() };
  };
}
